import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const About = () => {
  const [activeTab, setActiveTab] = useState('about');

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[400px] sm:h-[450px] md:h-[600px] overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          role="img"
          aria-label="À propos d'EDMF - Entreprise de bâtiment"
          style={{
            backgroundImage: `url('https://res.cloudinary.com/dizovx4yi/image/upload/v1747864145/ce927f1c-c053-4b5d-8341-08f679d77222_wantzu.png')`,
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#2D2A5D]/90 to-transparent"></div>
        </div>
        <div className="container mx-auto md:px-4 h-full flex items-center relative z-10">
          <div className="w-full max-w-2xl text-white">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold mt-8 md:mt-12 mb-3 md:mb-4">
              À Propos de EDMF
            </h1>
            <p className="text-sm md:text-lg mb-4 md:mb-8 max-w-sm sm:max-w-md md:max-w-2xl">
              Depuis plus de 15 ans, EDMF s'engage à fournir des services de construction et de rénovation de la plus haute qualité. Notre équipe de professionnels qualifiés met son expertise à votre service pour réaliser vos projets avec excellence et passion.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4">
              <Link
                to="/realisations"
                className="bg-red-600 hover:bg-red-700 text-white text-center text-sm md:text-base px-4 py-2 md:px-6 md:py-3 rounded-lg font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap"
              >
                Découvrir nos réalisations
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Tabs - Scrollable on mobile */}
      <section className="py-4 md:py-8 bg-gray-50 sticky top-0 z-20 shadow-md">
        <div className="container mx-auto md:px-4">
          <div className="flex items-center justify-start md:justify-center overflow-x-auto pb-2 md:pb-0 gap-2 md:gap-4 no-scrollbar">
            <button
              onClick={() => setActiveTab('about')}
              className={`px-4 py-2 md:px-6 md:py-3 rounded-lg text-xs md:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap flex-shrink-0 ${
                activeTab === 'about'
                  ? 'bg-[#2D2A5D] text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-200'
              }`}
            >
              <i className="fas fa-building mr-2"></i>
              Présentation
            </button>
            <button
              onClick={() => setActiveTab('values')}
              className={`md:px-4 py-2 md:px-6 md:py-3 rounded-lg text-xs md:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap flex-shrink-0 ${
                activeTab === 'values'
                  ? 'bg-[#2D2A5D] text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-200'
              }`}
            >
              <i className="fas fa-star mr-2"></i>
              Mission & Valeurs
            </button>
            {/* <button
              onClick={() => setActiveTab('partners')}
              className={`py-2 md:px-6 md:py-3 rounded-lg text-xs md:text-sm font-medium transition-colors cursor-pointer whitespace-nowrap flex-shrink-0 ${
                activeTab === 'partners'
                  ? 'bg-[#2D2A5D] text-white'
                  : 'bg-white text-gray-700 hover:bg-gray-200'
              }`}
            >
              <i className="fas fa-handshake mr-2"></i>
              Partenaires
            </button> */}
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-8 md:py-16 bg-white">
        <div className="container mx-auto md:px-4">
          {activeTab === 'about' && (
            // Historique de l'entreprise
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-8 md:mb-12">
                <h2 className="text-2xl md:text-3xl font-bold text-[#2D2A5D] mb-2 md:mb-4">Qui sommes nous</h2>
                <p className="text-gray-600 max-w-3xl mx-auto text-sm md:text-base">
                Ets Doudou Mendy et Fils (EDMF) est un etablissement inégalable spécialisée dans le domaine de la peinture et de travaux de bâtiment au Sénégal. Avec plus de 25 années d’expertise, nous nous distinguons par notre savoir-faire dans les domaines d’étanchéité, de maçonnerie, de la charpente et de l’électrification de bâtiment. Dans le but de respecter nos délais de chantiers, la société travaille avec des employés qualifiés et les meilleurs matériaux du marché. L'etablissement allie innovation, conseil personnalisé et excellent rapport qualité-prix pour répondre aux exigences de ses clients et assurer leur satisfaction.                </p>
              </div>
              {/* <div className="relative"> */}
                {/* Timeline line */}
                {/* <div className="absolute left-6 md:left-1/2 top-0 bottom-0 transform md:-translate-x-1/2 h-full w-1 bg-red-600"></div> */}
                {/* Timeline items */}
                {/* <div className="space-y-10 md:space-y-16"> */}
                  {/* Années et événements */}
                  {/* <div className="flex flex-col md:flex-row items-start md:items-center pl-12 md:pl-0">
                    <div className="md:w-1/2 md:pr-12 md:text-right mb-4 md:mb-0">
                      <div className="bg-white p-4 md:p-6 rounded-lg shadow-lg">
                        <h3 className="text-xl md:text-2xl font-bold text-[#2D2A5D] mb-1 md:mb-2">2010</h3>
                        <h4 className="text-lg md:text-xl font-semibold text-red-600 mb-2 md:mb-3">Fondation d'EDMF</h4>
                        <p className="text-gray-600 text-sm md:text-base">
                          Doudou Mendy fonde EDMF avec une équipe de trois personnes, spécialisée initialement dans les travaux de peinture et petite maçonnerie pour des clients particuliers.
                        </p>
                      </div>
                    </div>
                    <div className="z-10 absolute left-6 md:static md:flex md:items-center md:justify-center w-8 h-8 md:w-12 md:h-12 bg-red-600 rounded-full border-4 border-white shadow-md transform -translate-x-1/2 md:translate-x-0">
                      <i className="fas fa-flag text-white text-xs md:text-base"></i>
                    </div>
                    <div className="md:w-1/2 md:pl-12 mt-4 md:mt-0">
                      <div className="bg-gray-100 rounded-lg overflow-hidden h-48 md:h-64">
                        <img 
                          src="https://public.readdy.ai/ai/img_res/8fe76492087af38c243bda55b8ea79b6.jpg" 
                          alt="Fondation d'EDMF" 
                          className="w-full h-full object-cover object-center"
                        />
                      </div>
                    </div>
                  </div> */}
                  {/* Ajoutez ici les autres années */}
                {/* </div>
              </div> */}
            </div>
          )}
          {activeTab === 'values' && (
            // Mission et valeurs
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-8 md:mb-12">
                <h2 className="text-2xl md:text-3xl font-bold text-[#2D2A5D] mb-2 md:mb-4">Notre Mission & Nos Valeurs</h2>
                <p className="text-gray-600 max-w-3xl mx-auto text-sm md:text-base">
                  Chez EDMF, notre mission est de transformer vos espaces avec excellence et intégrité. Nos valeurs fondamentales guident chacune de nos actions et décisions.
                </p>
              </div>
              {/* Valeurs en grille responsive */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* Valeur 1 */}
                <div className="bg-white rounded-lg shadow-lg overflow-hidden transition-transform hover:scale-105">
                  <div className="h-32 md:h-48 bg-red-600 flex items-center justify-center">
                    <i className="fas fa-medal text-white text-4xl md:text-6xl"></i>
                  </div>
                  <div className="p-4 md:p-6">
                    <h3 className="text-lg md:text-xl font-bold text-[#2D2A5D] mb-2 md:mb-3">Excellence</h3>
                    <p className="text-gray-600 text-sm md:text-base">
                      Nous nous efforçons d'atteindre l'excellence dans chaque aspect de notre travail, garantissant des résultats qui dépassent vos attentes.
                    </p>
                  </div>
                </div>
                {/* Valeur 2 */}
                <div className="bg-white rounded-lg shadow-lg overflow-hidden transition-transform hover:scale-105">
                  <div className="h-32 md:h-48 bg-[#2D2A5D] flex items-center justify-center">
                    <i className="fas fa-handshake text-white text-4xl md:text-6xl"></i>
                  </div>
                  <div className="p-4 md:p-6">
                    <h3 className="text-lg md:text-xl font-bold text-[#2D2A5D] mb-2 md:mb-3">Intégrité</h3>
                    <p className="text-gray-600 text-sm md:text-base">
                      L'honnêteté et la transparence sont au cœur de notre approche. Nous travaillons avec intégrité à chaque étape de votre projet.
                    </p>
                  </div>
                </div>
                {/* Valeur 3 */}
                <div className="bg-white rounded-lg shadow-lg overflow-hidden transition-transform hover:scale-105 sm:col-span-2 lg:col-span-1">
                  <div className="h-32 md:h-48 bg-red-600 flex items-center justify-center">
                    <i className="fas fa-users text-white text-4xl md:text-6xl"></i>
                  </div>
                  <div className="p-4 md:p-6">
                    <h3 className="text-lg md:text-xl font-bold text-[#2D2A5D] mb-2 md:mb-3">Collaboration</h3>
                    <p className="text-gray-600 text-sm md:text-base">
                      Nous croyons en la force du travail d'équipe et de la collaboration, tant en interne qu'avec nos clients et partenaires.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
          {activeTab === 'partners' && (
            // Partenaires
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-8 md:mb-12">
                <h2 className="text-2xl md:text-3xl font-bold text-[#2D2A5D] mb-2 md:mb-4">Nos Partenaires</h2>
                <p className="text-gray-600 max-w-3xl mx-auto text-sm md:text-base">
                  EDMF collabore avec des partenaires de confiance pour vous offrir des services et produits de la plus haute qualité. Ces collaborations nous permettent d'innover et d'exceller dans tous nos projets.
                </p>
              </div>
              {/* Logos partenaires en grille responsive */}
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-6">
                {[1, 2, 3, 4, 5, 6].map((index) => (
                  <div key={index} className="bg-white rounded-lg shadow-md p-4 flex items-center justify-center h-24 md:h-32">
                    <div className="w-full h-full bg-gray-200 rounded flex items-center justify-center">
                      <span className="text-gray-500 text-sm font-medium">Logo Partenaire {index}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Call-to-Action Fixe */}
      <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-gray-200 pb-6 pt-2 md:py-3 z-30">
        <div className="container mx-auto px-4 flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
          <Link
            to="/"
            className="text-[#2D2A5D] hover:text-red-600 transition-colors cursor-pointer whitespace-nowrap text-sm md:text-base hidden sm:block"
          >
            <i className="fas fa-arrow-left mr-2"></i>Retour à l'accueil
          </Link>
          <div className="flex space-x-3 w-full sm:w-auto justify-center sm:justify-end">
            <Link
              to="/#contact"
              className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 md:px-4 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap flex-1 sm:flex-none text-center"
            >
              <i className="fas fa-phone-alt mr-1 md:mr-2"></i>Nous contacter
            </Link>
            <Link
              to="/"
              className="bg-[#2D2A5D] hover:bg-[#1F1C45] text-white px-3 py-2 md:px-4 md:py-2 rounded-lg text-xs md:text-sm font-medium transition-colors cursor-pointer !rounded-button whitespace-nowrap flex-1 sm:flex-none text-center sm:hidden"
            >
              <i className="fas fa-home mr-1"></i>Accueil
            </Link>
          </div>
        </div>
      </div>

      {/* Ajoutez un padding en bas pour éviter que le contenu ne soit caché par la barre fixe */}
      <div className="h-16 md:h-20"></div>
    </div>
  );
};

export default About;